import type { RemindMeRequest } from "@/modules/events/types/eventDetailsApi"
import type { UseMutationResult } from "@tanstack/react-query"

import { useMutation } from "@tanstack/react-query"

import { getRemindMe } from "@/modules/events/api/getRemindMe"

export const useRemindMe = (): UseMutationResult<void, Error, RemindMeRequest> =>
  useMutation<void, Error, RemindMeRequest>({ mutationFn: getRemindMe })
